<div class="ya-input-container-flexwidth">
  <select a11y_Select class="ya-input-text requestServiceTime" (change)="selectItem(items[$event.currentTarget.value])">
    <ng-container *ngFor="let item of items; let index = index">
      <option [value]="index" [selected]="item.selected">
        {{item.label}}
      </option>
    </ng-container>
  </select>
  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
</div>